var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from "./types";
var announcementLatestState = {
    data: null,
    error: null,
    loading: false,
};
var announcementReducer = function (state, action) {
    if (state === void 0) { state = announcementLatestState; }
    switch (action.type) {
        case Types.GET_ANNOUNCEMENT_LATEST_INIT:
            return __assign(__assign({}, state), { error: null, loading: true });
        case Types.GET_ANNOUNCEMENT_LATEST_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_ANNOUNCEMENT_LATEST_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_ANNOUNCEMENT_LATEST_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var AnnouncementReducer = {
    announcementLatestData: announcementReducer,
};
export var announcementLatestData = function (state) {
    return state.announcementLatestData.data ? state.announcementLatestData.data : null;
};
export var announcementLatestError = function (state) {
    return state.announcementLatestData.error;
};
export var isLoadingAnnouncementLatest = function (state) {
    return state.announcementLatestData.loading;
};
export default AnnouncementReducer;
